import { Navigate, useLocation } from 'react-router';
import { useAuth } from '@/providers/auth-provider';
import { type ReactNode } from 'react';

interface ProtectedRouteProps {
    children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex h-dvh items-center justify-center bg-primary">
                <div className="text-center">
                    <div className="mb-4 inline-block animate-spin">
                        <div className="size-8 border-4 border-brand border-t-transparent rounded-full" />
                    </div>
                    <p className="text-tertiary">Loading...</p>
                </div>
            </div>
        );
    }

    if (!user) {
        // Redirect to sign-in but save the location they were trying to access
        return <Navigate to="/sign-in" state={{ from: location }} replace />;
    }

    return children;
}
